import {
  FREQUENCY_OPTIONS,
  CALENDAR_FREQUENCIES,
  WEEKDAY_LABELS_SHORT,
  ORDINAL_LABELS,
  INTERVAL_UNIT_LABELS,
} from './constants';
import { DEFAULT_INTERVAL } from './canonicalize';
import { describeWeekdaysList, parseWeekdaysArray } from './weekdays';

export function hasRecurrence(rule) {
  return !isNeverRule(rule);
}

export function isNeverRule(rule) {
  if (rule == null) return true;
  if (typeof rule !== 'object') return true;
  const freq = String(rule.frequency || '').trim().toLowerCase();
  return !freq || freq === 'never';
}

function getRuleInterval(rule) {
  const n = Number(rule && rule.interval);
  return Number.isInteger(n) && n >= 1 ? n : DEFAULT_INTERVAL;
}

function describeIntervalPrefix(frequency, interval) {
  if (interval <= 1) {
    return (FREQUENCY_OPTIONS.find((o) => o.value === frequency) || {}).label || frequency;
  }
  const units = INTERVAL_UNIT_LABELS[frequency];
  if (!units) return frequency;
  const unit = interval === 1 ? units[0] : units[1];
  return `Every ${interval} ${unit}`;
}

export function describeRepeatRule(rule) {
  if (isNeverRule(rule)) return 'Never';

  const freq = rule.frequency;
  const interval = getRuleInterval(rule);
  const base = describeIntervalPrefix(freq, interval);

  if (freq === 'weekly') {
    const weekdays = parseWeekdaysArray(rule.weekdays);
    const daysLabel = describeWeekdaysList(weekdays);
    if (daysLabel && !(interval <= 1 && weekdays && weekdays.length === 1)) {
      return `${base} – ${daysLabel}`;
    }
    return base;
  }

  if (!CALENDAR_FREQUENCIES.includes(freq)) {
    return base;
  }

  if (rule.mode === 'nthWeekday') {
    const ord = ORDINAL_LABELS[rule.nth] || String(rule.nth);
    const day =
      Number.isInteger(rule.weekday) && rule.weekday >= 0 && rule.weekday <= 6
        ? WEEKDAY_LABELS_SHORT[rule.weekday]
        : `day ${rule.weekday}`;
    return `${base} – ${ord} ${day}`;
  }

  if (rule.mode === 'dayOfMonth' && rule.dayOfMonth != null) {
    return `${base} – Day ${rule.dayOfMonth}`;
  }

  return base;
}
